module.exports = __webpack_public_path__ + "static/gallery_13-e2b0515e9a5e3ad6fce976dfd7b5e90b.jpg";